export const APP_VERSION="v0.2.0_rc165_cx | b82973f6ec9e8621cd2761049cc17814a3bfcf98"
